import { Pin, PinOff } from 'lucide-react';
import type { ChatSummary } from '../api/client.ts';
import './HoldMenu.css';

/**
 * What a long press on a chat row offers, which today is one thing.
 *
 * A one-item menu rather than the press doing that one thing outright: a chat
 * row is what opens a conversation, and a gesture on it that silently rearranged
 * the list would be a press that did something nobody asked to confirm. The card
 * also has the room this will need — «без звука» and «очистить» belong here when
 * they exist, and adding a second row then is a line, not a redesign.
 *
 * Bots never get here: the list decides that before opening this (see ChatList),
 * and the server refuses a pin on one anyway. So there is no disabled row to
 * explain — the menu simply does not open on a bot's row, the same way the
 * conversation header draws no call button where there is nobody to ring.
 */
export function ChatActions({
  chat,
  onClose,
  onPin,
}: {
  chat: ChatSummary;
  onClose: () => void;
  onPin: (pinned: boolean) => void;
}) {
  const pinned = chat.pinnedAt !== null;

  return (
    <div className="hold-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      {/* Which chat is being acted on. The row it was held on is behind a dark
          overlay by now, so the name has to be repeated here to be readable. */}
      <div className="hold-preview" onClick={(event) => event.stopPropagation()}>
        {chat.title}
      </div>

      <div className="hold-menu" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          className="hold-item"
          onClick={() => {
            onPin(!pinned);
            onClose();
          }}
        >
          {pinned ? <PinOff size={18} /> : <Pin size={18} />}
          {pinned ? 'Открепить' : 'Закрепить'}
        </button>
      </div>
    </div>
  );
}
